// extracted by mini-css-extract-plugin
module.exports = {"container":"cookie-consent-CookieConsentContainer-container-a0f4bc7c"};